import * as React from 'react';
import styled from 'styled-components';

import TextInputBase from '../../../../components/TextInput/NewTextInput';

interface Props {
  className?: string;
  value: number;
  onValueChange: (value: number) => void;
  postfix?: string;
  maxValue?: number;
}

const CalculatorField = ({ className, value, onValueChange, postfix, maxValue }: Props) => (
  <WrapperDiv className={className}>
    <TextInput
      inputType="calculator"
      onChange={e => {
        const num = Number(e.target.value);
        if (Number.isNaN(num) || (maxValue && num > maxValue)) return onValueChange(value);

        onValueChange(num);
      }}
      value={`${value}`}
    />
    {postfix && <span>{postfix}</span>}
  </WrapperDiv>
);

export default CalculatorField;

const WrapperDiv = styled.div`
  position: relative;

  span {
    font-size: 24px;
    position: absolute;
    top: 4px;
    right: 17px;
  }
`;

const TextInput = styled(TextInputBase)`
  padding: 0;
`;
